module.exports = "https://web-assets.ifttt.com/packs/media/docs/trigger2-af0e7f95.png";